<!-- components/SearchResults.vue -->
<template>
  <div class="search-results">
    <div v-if="hits && hits.length > 0">
      <slot :items="hits"></slot>
    </div>
    <div v-else-if="!isLoading">
      <slot name="no-results">
        <p class="text-center">No results found</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResults',
  props: {
    hits: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>